<div class="w-full grid grid-cols-12 justify-end gap-4">
  <div class="col-span-12 xl:col-span-2 2xl:col-span-5">
  </div>

  <div class="col-span-12 md:col-span-12 lg:col-span-8 xl:col-span-6 2xl:col-span-5">
    <input
      pInputText
      fluid
      id="search"
      [(ngModel)]="searchText"
      (keyup.enter)="applyFilters()"
      placeholder="Buscar por fuente de emisión o referencia de actividad" />
  </div>

  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Filtrar"
      icon="pi pi-search"
      (onClick)="applyFilters()"
      type="button"
      fluid
    />
  </div>
  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Limpiar"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="clearFilters()"
      type="button"
      fluid
    />
  </div>
</div>
